import {
  OrderReviewGigaQueryDocument,
  PaymentOrderInfoDocument,
  UpdateOrderContactsDocument,
} from '__generated__/atlas-types'

import { atlas } from 'graphql/tags'

import {
  UseOrdersMutationReturnType,
  useOrdersMutation,
} from 'features/Orders/orders.hooks'

atlas`#graphql
  mutation UpdateOrderContacts($input: UpdateOrderInfoInput) {
    updateOrderInfo(input: $input) {
      updatedOrderIds
    }
  }
`

//TODO(palvarez): refactor to use updatedOrders so we don't have to refetch the entire order again

export const useUpdateOrderContacts = (
  orderId: string,
): UseOrdersMutationReturnType =>
  useOrdersMutation(UpdateOrderContactsDocument, {
    refetchQueries: [
      {
        query: OrderReviewGigaQueryDocument,
        variables: {
          filters: {
            ids: [orderId],
          },
          traitCodes: 'COLOR',
          limit: 20,
          offset: 0,
        },
      },
      {
        query: PaymentOrderInfoDocument,
        variables: {
          filters: {
            ids: [orderId],
          },
        },
      },
    ],
  })
